import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { HeadingComponent } from 'src/app/components/heading/heading.component';
import { TextInputControl } from 'src/app/form-controls/text-input/text-input.control';
import { UnitQuantityResult, UnitQuantityResultControl } from 'src/app/form-controls/unit-quantity-result/unit-quantity-result.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { BloodGasResultsActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface BloodGasResultsActionFormGroup {
	patientName: FormControl<string | null>;
	sampleType: FormControl<string | null>;
	t: FormControl<UnitQuantityResult | null>;
	fO2: FormControl<UnitQuantityResult | null>;
	ph: FormControl<UnitQuantityResult | null>;
	pCO2: FormControl<UnitQuantityResult | null>;
	pO2: FormControl<UnitQuantityResult | null>;
	ctHb: FormControl<UnitQuantityResult | null>;
	sO2: FormControl<UnitQuantityResult | null>;
	hCtc: FormControl<UnitQuantityResult | null>;
	fCOHb: FormControl<UnitQuantityResult | null>;
	fMetHb: FormControl<UnitQuantityResult | null>;
	cKPlus: FormControl<UnitQuantityResult | null>;
	cNaPlus: FormControl<UnitQuantityResult | null>;
	cCa2Plus: FormControl<UnitQuantityResult | null>;
	cClMinus: FormControl<UnitQuantityResult | null>;
	cGlu: FormControl<UnitQuantityResult | null>;
	cLac: FormControl<UnitQuantityResult | null>;
	ctBil: FormControl<UnitQuantityResult | null>;
	cUrea: FormControl<UnitQuantityResult | null>;
	cCrea: FormControl<UnitQuantityResult | null>;
	pHT: FormControl<UnitQuantityResult | null>;
	pCO2T: FormControl<UnitQuantityResult | null>;
	cBaseEcfC: FormControl<UnitQuantityResult | null>;
	cHCO3EcfC: FormControl<UnitQuantityResult | null>;
}

@Component({
	selector: 'app-blood-gas-results-action-controls-v2',
	templateUrl: './blood-gas-results-action-controls-v2.component.html',
	styleUrls: ['../../../common.scss', './blood-gas-results-action-controls-v2.component.scss'],
	imports: [HeadingComponent, ReactiveFormsModule, TextInputControl, UnitQuantityResultControl, CommonActionControlsComponent, ActionFormComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BloodGasResultsActionControlsComponentV2 implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: BloodGasResultsActionV2;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as BloodGasResultsActionV2;
	}

	@Input() form!: FormGroup<BloodGasResultsActionFormGroup>;
	@Input() item!: Row | null;

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('patientName', this.formBuilder.control(this.action?.patientName ?? null));
		this.form.addControl('sampleType', this.formBuilder.control(this.action?.sampleType ?? null));
		this.form.addControl('t', this.formBuilder.control(this.action?.t ?? null));
		this.form.addControl('fO2', this.formBuilder.control(this.action?.fO2 ?? null));
		this.form.addControl('ph', this.formBuilder.control(this.action?.ph ?? null));
		this.form.addControl('pCO2', this.formBuilder.control(this.action?.pCO2 ?? null));
		this.form.addControl('pO2', this.formBuilder.control(this.action?.pO2 ?? null));
		this.form.addControl('ctHb', this.formBuilder.control(this.action?.ctHb ?? null));
		this.form.addControl('sO2', this.formBuilder.control(this.action?.sO2 ?? null));
		this.form.addControl('hCtc', this.formBuilder.control(this.action?.hCtc ?? null));
		this.form.addControl('fCOHb', this.formBuilder.control(this.action?.fCOHb ?? null));
		this.form.addControl('fMetHb', this.formBuilder.control(this.action?.fMetHb ?? null));
		this.form.addControl('cKPlus', this.formBuilder.control(this.action?.cKPlus ?? null));
		this.form.addControl('cNaPlus', this.formBuilder.control(this.action?.cNaPlus ?? null));
		this.form.addControl('cCa2Plus', this.formBuilder.control(this.action?.cCa2Plus ?? null));
		this.form.addControl('cClMinus', this.formBuilder.control(this.action?.cClMinus ?? null));
		this.form.addControl('cGlu', this.formBuilder.control(this.action?.cGlu ?? null));
		this.form.addControl('cLac', this.formBuilder.control(this.action?.cLac ?? null));
		this.form.addControl('ctBil', this.formBuilder.control(this.action?.ctBil ?? null));
		this.form.addControl('cUrea', this.formBuilder.control(this.action?.cUrea ?? null));
		this.form.addControl('cCrea', this.formBuilder.control(this.action?.cCrea ?? null));
		this.form.addControl('pHT', this.formBuilder.control(this.action?.pHT ?? null));
		this.form.addControl('pCO2T', this.formBuilder.control(this.action?.pCO2T ?? null));
		this.form.addControl('cBaseEcfC', this.formBuilder.control(this.action?.cBaseEcfC ?? null));
		this.form.addControl('cHCO3EcfC', this.formBuilder.control(this.action?.cHCO3EcfC ?? null));
	}
}
